import React, {useEffect, useState} from "react";
import {useGlobal} from "../../Store";
import {Link} from "react-router-dom";
import {postData} from "../../Utils/Server";
import Endpoints from "../../Constants/Endpoints";
import {ERROR, Notify, SUCCESS} from "../../Utils/Notify";
import {goToPage, updateDocumentTitle} from "../../Utils/Common";
import {useHistory} from "react-router-dom";
import PageLayout from "../Layout/PageLayout";
import {Button, Card, FormField, Select, TextInput} from "../UI";

const NewArea = props => {

    let history = useHistory();
    const [globalState, globalActions] = useGlobal();
    const [isLoading, setIsLoading] = useState(false);
    const [name, setName] = useState('');
    const [centreLat, setCentreLat] = useState(0);
    const [centreLng, setCentreLng] = useState(0);
    const [radius, setRadius] = useState(10);
    const [countryId, setCountryId] = useState('');
    const [countries, setCountries] = useState([]);

    useEffect(() => {
        updateDocumentTitle("Add new area")
        postData(Endpoints.COUNTRY_LIST, new FormData())
            .then(res => res.json())
            .then(res => {
                if (res.success === 1 && Array.isArray(res.data)) {
                    setCountries(res.data);
                }
            })
            .catch(error => console.log(error));
    }, []);

    const submitForm = e => {
        e.preventDefault();

        if (!countryId) {
            Notify("Please select a country", ERROR);
            return;
        }

        let data = new FormData();
        data.append("name", name)
        data.append("centre_lat", centreLat)
        data.append("centre_lng", centreLng)
        data.append("radius", radius)
        data.append("country_id", countryId)

        setIsLoading(true);

        postData(Endpoints.AREA_ADD, data)
            .then(res => res.json())
            .then(res => {
                setIsLoading(false);
                if (res.success === 1) {
                    setName('');
                    Notify(res.data, SUCCESS);
                    goToPage(history, "/areas")
                } else {
                    if (Array.isArray(res.data)) {
                        Notify(res.message[0], ERROR);
                    } else {
                        Notify(res.message, ERROR);
                    }
                }
            })
            .catch((error) => {
                setIsLoading(false);
                console.log(error)
            });
    }


    return (
        <PageLayout
            title="Create a new area"
            actions={
                <Link to="/areas">
                    <Button variant="outline">Back to areas</Button>
                </Link>
            }
        >
            <Card style={{maxWidth: 620}}>
                <form>
                    <FormField label="Name" required>
                        <TextInput
                            type="text"
                            required={true}
                            placeholder="Name"
                            value={name}
                            onChange={e => setName(e.target.value)}
                        />
                    </FormField>

                    <FormField label="Country" required>
                        <Select value={countryId} onChange={e => setCountryId(e.target.value)} required>
                            <option value="">Select a country</option>
                            {countries.map(c => (
                                <option key={c.id} value={c.id}>{c.name} ({c.currency})</option>
                            ))}
                        </Select>
                    </FormField>

                    <FormField label="Centre latitude" required>
                        <TextInput
                            type="text"
                            required={true}
                            placeholder="Centre latitude"
                            value={centreLat}
                            onChange={e => setCentreLat(e.target.value)}
                        />
                    </FormField>

                    <FormField label="Centre longitude" required>
                        <TextInput
                            type="text"
                            required={true}
                            placeholder="Centre longitude"
                            value={centreLng}
                            onChange={e => setCentreLng(e.target.value)}
                        />
                    </FormField>

                    <FormField label="Radius in KM" required>
                        <TextInput
                            type="text"
                            required={true}
                            placeholder="Radius"
                            value={radius}
                            onChange={e => setRadius(e.target.value)}
                        />
                    </FormField>

                    <Button type="submit" loading={isLoading} onClick={e => submitForm(e)}>Create</Button>
                </form>
            </Card>
        </PageLayout>
    )
};

export default NewArea;
